import MuiDrawer, { DrawerProps } from '@mui/material/Drawer';

export interface IDrawerProps extends DrawerProps { };

const Drawer = (props: IDrawerProps): JSX.Element => {
  const { ...rest } = props;
  return <MuiDrawer {...rest} />;
};

export default Drawer;